import React from 'react';
import { Headphones, Ticket, Users } from 'lucide-react';
import { Card, CardContent } from './ui/card';
import { useNavigate } from 'react-router-dom';

const CTACards = () => {
  const navigate = useNavigate();

  const cards = [
    {
      title: 'Remote Support',
      description: 'Get instant technical assistance from our expert team',
      icon: Headphones,
      image: 'https://images.unsplash.com/photo-1753715613382-dc3e8456dbc9?w=800&q=80',
      link: '/remote-support',
      color: 'bg-blue-600'
    },
    {
      title: 'Open a Ticket',
      description: 'Submit your IT queries and get expert support',
      icon: Ticket,
      image: 'https://images.unsplash.com/photo-1598970434795-0c54fe7c0648?w=800&q=80',
      link: '/open-ticket',
      color: 'bg-cyan-600'
    },
    {
      title: 'Hire Us',
      description: 'Partner with us for comprehensive IT solutions',
      icon: Users,
      image: 'https://images.unsplash.com/photo-1551135049-8a33b5883817?w=800&q=80',
      link: '/#contact',
      color: 'bg-indigo-600'
    }
  ];

  const handleCardClick = (link) => {
    if (link.startsWith('/#')) {
      const elementId = link.substring(2);
      const element = document.getElementById(elementId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      navigate(link);
    }
  };

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {cards.map((card) => (
            <Card 
              key={card.title} 
              className="group cursor-pointer overflow-hidden border border-slate-200 hover:border-blue-500 transition-all duration-500 hover:shadow-2xl hover:-translate-y-2"
              onClick={() => handleCardClick(card.link)}
            >
              <div className="relative h-56 overflow-hidden">
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-slate-950 via-slate-950/60 to-transparent"></div>
                <div className="absolute bottom-4 left-4 right-4">
                  <div className="flex items-center gap-3 mb-2">
                    <div className={`p-2.5 ${card.color} rounded-lg shadow-lg`}>
                      <card.icon className="w-5 h-5 text-white" />
                    </div>
                    <h3 className="text-xl font-bold text-white">
                      {card.title}
                    </h3>
                  </div>
                </div>
              </div>
              <CardContent className="p-6">
                <p className="text-slate-600 leading-relaxed">
                  {card.description}
                </p>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CTACards;